import { IPageData } from '@umu/umu-types';
import { Page } from 'businessCommon/src/services';

class CommercializePage<T extends IPageData> extends Page<T> {
    constructor(data: T) {
        super({ gdprConfig: { disableDeclineAlways: true, disableDefaultDecline: true }, ...data });
    }

    protected setupCMSPageTitle(getPageTitle: () => string, getAppData: (key: string) => any) {
        const currentSystem = getAppData('SYSTEM').toLowerCase();
        if (currentSystem !== 'com' && currentSystem !== 'en') {
            this.setupPageTitle(getPageTitle());
        }
    }
}
export default CommercializePage;
